import { useEffect, useRef, useState } from "react";
import * as St from "./styles";
import ContainerFlex, { PrintableBodyWrapper } from "components/ContainerFlex";
import Endpoints from "services/api/endpoints";
import useApi, { ApiMethod } from "hooks/useApi";
import { getItemLocalStore } from "utils/storeUtils";
import { LOCAL_STORE_CLIENTE } from "../../../../constants";
import { RouteNames } from "routes/routes";
import { useHistory } from "react-router-dom";
import { showMessage } from "utils/messages";
import { hiddenCardNumberTwo, moneyMask } from "utils/mask";
import moment from "moment";
import ReactToPrint from "react-to-print";
import AppButton from "components/AppButton/AppButton";

const ParcelamentoFatura = () => {
  const history = useHistory();
  const { cpf } = getItemLocalStore(LOCAL_STORE_CLIENTE);
  const [data, setData] = useState<any>([]);
  const today = new Date();
  const currentDay = moment(today).format("DD/MM/YYYY");
  const componentRef = useRef<HTMLDivElement>(null);

  const GetInstallmentsInvoice = useApi<any>(
    Endpoints.cobranca.getCharge.replace("PARAM_CPF", cpf),
    ApiMethod.GET
  );

  const clickBack = () => {
    history.push(RouteNames.ATENDIMENTO_FATURA);
  };

  const getInstallmentsInvoice = async () => {
    try {
      const response = await GetInstallmentsInvoice.callApi();
      if (response.status >= 200 && response.status <= 300) {
        setData(response.data);
      } else {
        showMessage("warning", "Atenção!", response.mensagem as string);
        history.push(RouteNames.ATENDIMENTO_FATURA);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (cpf) {
      getInstallmentsInvoice();
    }
    // getInstallmentsInvoice vem de useApi/e nao e memoizada; incluir causaria
    // refetch em loop a cada render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cpf]);

  return (
    <ContainerFlex>
      <St.TitleH1>Fatura - Parcelamento</St.TitleH1>
      <ContainerFlex row padding={1}>
        <ContainerFlex>
          <ContainerFlex>
            <ContainerFlex>
              <ContainerFlex style={{ paddingLeft: "7rem" }}>
                <St.SpanTitleInvoice>Fatura Atual</St.SpanTitleInvoice>
                <St.BiggerTextInvoice>
                  {moneyMask(data.valor)}
                </St.BiggerTextInvoice>
                <St.SpanTitleInvoice>
                  Opções de parcelamento:{" "}
                </St.SpanTitleInvoice>
                <ContainerFlex
                  padding={15}
                  color="#fbfbfb"
                  width={80}
                  height={50}
                  maxWidth={100}
                  maxHeight={100}
                  scroll
                  hidden
                  borderRadius={10}
                >
                  {data?.parcelamento?.map((el: any, index: any) => {
                    return (
                      <St.SpanTextInvoiceBold>
                        Entrada: {moneyMask(el.entrada)} + {el.quantidade - 1}x
                        de {moneyMask(el.valor)}
                      </St.SpanTextInvoiceBold>
                    );
                  })}
                </ContainerFlex>
                {data?.taxaJurosParcelamentoMensal &&
                  data?.taxaJurosParcelamentoAnual && (
                    <St.SpanDescription>
                      Taxa de juros de{" "}
                      {data?.taxaJurosParcelamentoMensal
                        .toString()
                        .replace(".", ",")}
                      % a.m ou{" "}
                      {data?.taxaJurosParcelamentoAnual
                        .toString()
                        .replace(".", ",")}
                      % a.a.
                    </St.SpanDescription>
                  )}
                <St.SpanDescription>
                  Parcelamento sujeito a incidência de imposto IOF
                </St.SpanDescription>
              </ContainerFlex>
            </ContainerFlex>
          </ContainerFlex>
        </ContainerFlex>
        <ContainerFlex center>
          <ContainerFlex center padding={15}>
            <ContainerFlex
              padding={15}
              color="#fbfbfb"
              width={80}
              height={60}
              maxWidth={100}
              maxHeight={350}
              scroll
              hidden
              marginTop={20}
              borderRadius={10}
            >
              <PrintableBodyWrapper ref={componentRef}>
                <ContainerFlex row>
                  <St.TitleInvoiceTextValue>
                    Parcelamento Fatura TeuCard
                  </St.TitleInvoiceTextValue>
                  <St.DateInvoiceTextValue>
                    Data: {currentDay && currentDay}
                  </St.DateInvoiceTextValue>
                </ContainerFlex>
                <ContainerFlex row>
                  <ContainerFlex>
                    <St.SpanTextTitleBold>Cliente:</St.SpanTextTitleBold>
                    <St.SpanTextTitle>{data?.nomeCliente}</St.SpanTextTitle>
                  </ContainerFlex>
                  <ContainerFlex end align="flex-end">
                    <St.SpanTextTitleBold>Cartão:</St.SpanTextTitleBold>
                    <St.SpanTextTitle>
                      {data?.numeroCartao &&
                        hiddenCardNumberTwo(
                          data?.numeroCartao,
                          4,
                          12,
                          ".****.****."
                        )}
                    </St.SpanTextTitle>
                  </ContainerFlex>
                </ContainerFlex>
                <St.Dividers />
                <St.SpanTextTitleBold>
                  Resumo da fatura atual
                </St.SpanTextTitleBold>
                <ContainerFlex>
                  <ContainerFlex row justifyContent="space-between">
                    <St.SpanTextTitle>Vencimento:</St.SpanTextTitle>
                    <ContainerFlex end align="flex-end" row>
                      <St.SpanTextInstallments>
                        {moment(data?.dataVencimento).format("DD/MM/YYYY")}
                      </St.SpanTextInstallments>
                    </ContainerFlex>
                  </ContainerFlex>
                  <ContainerFlex row justifyContent="space-between">
                    <St.SpanTextTitle>Status:</St.SpanTextTitle>
                    <ContainerFlex end align="flex-end" row>
                      <St.SpanTextInstallments>
                        {data?.statusDescricao}
                      </St.SpanTextInstallments>
                    </ContainerFlex>
                  </ContainerFlex>
                  <ContainerFlex row justifyContent="space-between">
                    <St.SpanTextTitle>Valor total:</St.SpanTextTitle>
                    <ContainerFlex end align="flex-end" row>
                      <St.SpanTextInstallments>
                        {moneyMask(data?.valor)}
                      </St.SpanTextInstallments>
                    </ContainerFlex>
                  </ContainerFlex>
                  <ContainerFlex row justifyContent="space-between">
                    <St.SpanTextTitle>Valor mínimo:</St.SpanTextTitle>
                    <ContainerFlex end align="flex-end" row>
                      <St.SpanTextInstallments>
                        {moneyMask(data?.valorMinimoRecebido)}
                      </St.SpanTextInstallments>
                    </ContainerFlex>
                  </ContainerFlex>
                </ContainerFlex>
                <St.Dividers />
                <St.SpanTextTitleBold>
                  Escolha uma opção de parcelamento da fatura:
                </St.SpanTextTitleBold>
                {data?.parcelamento?.map((el: any, index: any) => {
                  return (
                    <ContainerFlex row justifyContent="space-between">
                      <St.SpanTitleValue>Entrada:</St.SpanTitleValue>
                      <St.SpanTextValue>
                        {moneyMask(el.entrada)}
                      </St.SpanTextValue>
                      <ContainerFlex end align="flex-end" row>
                        <St.SpanTextInstallments>
                          + {el.quantidade - 1}x de {moneyMask(el.valor)}
                        </St.SpanTextInstallments>
                      </ContainerFlex>
                    </ContainerFlex>
                  );
                })}
                <St.Dividers />
                {data?.taxaJurosParcelamentoMensal &&
                  data?.taxaJurosParcelamentoAnual && (
                    <St.SpanTextTitleBold>
                      Taxa de juros de{" "}
                      {data?.taxaJurosParcelamentoMensal
                        .toString()
                        .replace(".", ",")}
                      % a.m ou{" "}
                      {data?.taxaJurosParcelamentoAnual
                        .toString()
                        .replace(".", ",")}
                      % a.a.
                    </St.SpanTextTitleBold>
                  )}
                <br />
                <St.SpanTextTitleBold>
                  Parcelamento sujeito a incidência de imposto IOF
                </St.SpanTextTitleBold>
                <br />
                <St.SpanTextTitleBold>
                  Para ativar o parcelamento, basta pagar no caixa da loja, o
                  valor exato da entrada.
                </St.SpanTextTitleBold>
                <br />
                <St.SpanTextTitleBold>
                  Proibido arredondar o valor!
                </St.SpanTextTitleBold>
              </PrintableBodyWrapper>
            </ContainerFlex>
          </ContainerFlex>
        </ContainerFlex>
      </ContainerFlex>
      <ContainerFlex center horizontal row space>
        <AppButton
          content="Voltar"
          route={RouteNames.ATENDIMENTO_FATURA}
          outlined={true}
          click={clickBack}
          hidden={false}
        />
        <ReactToPrint
          trigger={() => <button className="normal">Imprimir</button>}
          content={() => componentRef.current}
        />
      </ContainerFlex>
    </ContainerFlex>
  );
};

export default ParcelamentoFatura;
